<script>
import router from "@/router";

export default {
  name: "ListMixin",
  methods: {
    openInNewTab(url) {
      window.open(router.resolve(url).href, '_blank', 'noopener')
    },
    openTooltipList(string){
      let tooltip = this.$t('base.open')
      if(string){
        tooltip = string
      }
      return '<div style="display: flex; align-items: center"><span>' + tooltip + '&nbsp;</span>' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24"><title>open-in-new</title><path ' +
        'd="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 ' +
        '5,21H19A2,2 0 0,0 21,19V12H19V19Z" fill="#8D8D8D"/></svg></div>'
    },
  }
}
</script>

<style lang="scss" scoped>
a {
  color: #343434;
  border-bottom: 1px solid #EFEFEF;
}
</style>